export default {
    addBanner: {
        method: "POST",
        url: '/manage-system/banner',
        name: 'banner新增'
    },
    updateBanner: {
        method: 'PUT',
        url: '/manage-system/banner',
        name: 'banner编辑',
    },
    bannerList: {
        method: 'POST',
        url: '/manage-system/banner/page',
        name: 'banner分页查询',
    },
    bannerFreeze: {
        method: "PUT",
        url: '/manage-system/banner/freeze/{id}',
        name: 'banner冻结'
    },
    bannerUnfreeze: {
        method: "PUT",
        url: '/manage-system/banner/unfreeze/{id}',
        name: 'banner冻结'
    },
    topBanner: {
        method: "PUT",
        url: '/manage-system/banner/top/{id}',
        name: 'banner置顶'
    },
    detailBanner: {
        method: "GET",
        url: '/manage-system/banner/{id}',
        name: 'banner详情'
    },
    deleteBanner: {
        method: 'DELETE',
        url: '/manage-system/banner/{id}',
        name: 'banner删除',
    },
    addNews: {
        method: "POST",
        url: '/manage-system/news',
        name: '新增资讯信息'
    },
    updateNews: {
        method: 'PUT',
        url: '/manage-system/news',
        name: '修改资讯信息',
    },
    newsList: {
        method: "POST",
        url: '/manage-system/news/page',
        name: '资讯管理列表'
    },
    newsFreeze: {
        method: "PUT",
        url: '/manage-system/news/freeze/{id}',
        name: '冻结资讯信息'
    },
    newsUnfreeze: {
        method: "PUT",
        url: '/manage-system/news/unfreeze/{id}',
        name: '解冻资讯信息'
    },
    newsTop: {
        method: "PUT",
        url: '/manage-system/news/top/{id}',
        name: '资讯置顶'
    },
    detailNews: {
        method: 'GET',
        url: '/manage-system/news/{id}',
        name: '查看资讯信息',
    },
    deleteNews: {
        method: "DELETE",
        url: '/manage-system/news/{id}',
        name: '删除资讯信息'
    },
    state: {
        method: "POST",
        url: '/manage-system/banner/state',
        name: '广告位上下架'
    },
    addRecommend: {
        method: "POST",
        url: '/manage-system/recommend/code',
        name: '新增推荐码'
    },
    disabledRecommend: {
        method: "PUT",
        url: '/manage-system/recommend/code/disable/{id}',
        name: '冻结推荐码'
    },
    enabledRecommend: {
        method: "POST",
        url: '/manage-system/recommend/code/enable',
        name: '解冻推荐码'
    },
    recommendList: {
        method: "POST",
        url: '/manage-system/recommend/code/page',
        name: '查询推荐码'
    },
    recommendExport: {
        method: "POST",
        url: '/manage-system/recommend/code/export',
        name: '打包下载推荐码'
    },
    getMiniSellActivityTicket: {
        method: "POST",
        url: '/manage-system/ticket/getMiniSellActivityTicket',
        name: '获取小程序展现的活动票券'
    },
    getMiniSellTicket: {
        method: "POST",
        url: '/manage-system/ticket/getMiniSellTicket',
        name: '获取小程序展现的票券'
    },
    adjustTicketPosition: {
        method: "POST",
        url: '/manage-system/ticket/adjustTicketPosition',
        name: '位置调整'
    },
}